import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let WholePortionWetPreparationMultiTraySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
        </ListFieldSection>
        <WorksheetGridFieldSection name="WetMassMeasurements">
          <WorksheetRecordGrid
            name="WetMassMeasurements"
            orientation="horizontal"
            rowHeaderWidth={200}
            recordProps={{
              preventRemove: (i) => i === 0,
              width: 130,
              enforceAtLeastOneRecord: true,
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete drying tray',
                confirmText: 'Are you sure you want to delete the drying tray? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={[
              { name: 'TareMass', component: <Field input={<NumericInput />} /> },
              {
                name: 'TareAndWetMass',
                component: <Field input={<NumericInput />} />,
              },
              {
                name: 'WetMass',
                component: <Field input={<TextOutput />} />,
              },
            ]}
          />
        </WorksheetGridFieldSection>
        <ListFieldSection>
          <Field input={<TextOutput />} name="WetMass" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

WholePortionWetPreparationMultiTraySection = withInjectedProps(WholePortionWetPreparationMultiTraySection);

export { WholePortionWetPreparationMultiTraySection };
export default WholePortionWetPreparationMultiTraySection;
